import { render, staticRenderFns } from "./MemberRole.vue?vue&type=template&id=697e903a&"
import script from "./MemberRole.vue?vue&type=script&lang=ts&"
export * from "./MemberRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports